const variables = {
    en: {
        leaderboard: 'Leaderboard',
        stream_swap_test_net: 'StreamSwap Mainnet Leaderboard',
    },
};

export default variables;
